<!--
    @生命全周期-item
-->
<template>
    <div class="project_com_item" @click="handleCommand(data)">
        <div class="item_top">
            <div class="item_top_title" style="display:flex;align-items: center;">
                <div class="flagTag" v-if="isShowTag" :class="setClassName()">{{data.regionName}}</div>
                <div style="height:32px;line-height:32px;">
                    <span class="title" >[{{ data.tradePlatfBidSectionCode }}] </span>
                    <span class="title">{{ data.bidSectionName }}</span>
                    <span class="tag" v-if="data.qualificationModeName">{{ data.qualificationModeName }}</span>
                    <span class="tag" v-if="data.tenderModeName">{{ data.tenderModeName }}</span>
                  <span class="tag" v-if="data.isReEvaluation === '1'" style="color: red; border: 1px solid red; padding: 2px 6px; border-radius: 4px; font-weight: bold; font-size: 16px;">复评</span>
                </div>
            </div>
            <div class="item_top_time">
                <span>
                    <template v-if="data.warnItemCount == 0"></template>
                    <template v-else-if="data.warnItemCount <= 5">
                        <!-- <img src="../../../assets/img/jingyellow.png" alt="">
                        -->
                        图片1
                    </template>
                    <template v-else>
                        <!-- <img src="../../../assets/img/jingred.png" alt="">
                        -->
                        图片2
                    </template>
                    <!-- 项目预警项：
					<span @click.stop="jumps(data.bidSectionCode)"
                    :class="data.warnItemCount == 0 ? 'zero' : data.warnItemCount <= 5 ? 'one' : 'two'">{{ data.warnItemCount }}条</span>-->
                </span>
            </div>
        </div>
        <div class="my_padding">
            <div class="item_middle">
                <div v-if="type != 4">
                    <p>
                        <span class="item_subtitle" v-if="systemType == 'GC'">招标人：</span>
                        <span class="item_subtitle" v-if="systemType == 'CG'">采购人：</span>
                        <span
                            class="item_subtitle"
                            v-if="systemType == 'CQ' || systemType == 'GT'"
                        >出让人：</span>
                        <span class="content">{{ data.tendererName | projectIsEmpty }}</span>
                    </p>
                    <p>
                        <span
                            class="item_subtitle"
                            v-if="systemType == 'CQ' || systemType == 'GT'"
                        >竞得人：</span>
                        <span class="item_subtitle" v-else>中标人：</span>
                        <span class="content">{{ data.winerName | projectIsEmpty }}</span>
                    </p>
                </div>
                <div v-if="type != 4">
                    <p>
                        <span class="item_subtitle" v-if="systemType == 'GC'">招标代理：</span>
                        <span class="item_subtitle" v-if="systemType == 'CG'">采购代理：</span>
                        <span
                            class="item_subtitle"
                            v-if="systemType == 'CQ' || systemType == 'GT'"
                        >经纪代理：</span>
                        <span class="content">{{ data.tenderAgencyName | projectIsEmpty }}</span>
                    </p>
                    <p>
                        <span
                            class="item_subtitle"
                            v-if="systemType == 'CQ' || systemType == 'GT'"
                        >成交价：</span>
                        <span class="item_subtitle" v-else>中标价：</span>
                        <span
                            class="content"
                        >{{ data.winBidPrice ? data.winBidPrice + '元' : data.winBidPrice | projectIsEmpty }}</span>
                    </p>
                </div>
                <div v-if="type != 4">
                    <p>
                        <span
                            class="item_subtitle"
                            v-if="systemType == 'CQ' || systemType == 'GT'"
                        >限时竞价时间：</span>
                        <span class="item_subtitle" v-else>开标时间：</span>
                        <span class="content">
                            {{ data.openTime | projectIsEmpty }}
                            <template
                                v-if="data.passOpenDate && data.passOpenDate >= 0"
                            >
                                <div v-if="data.passOpenDate"></div>
                                <i v-if="data.passOpenDate && data.passOpenDate == 0">今日开标</i>
                                <i
                                    v-if="data.passOpenDate && data.passOpenDate > 0"
                                >{{ data.passOpenDate + '天后' }}</i>
                            </template>
                        </span>
                    </p>
                    <p>
                        <span class="item_subtitle">完结日期：</span>
                        <span class="content">{{ data.finishTime | projectIsEmpty }}</span>
                    </p>
                </div>
                <div v-if="type == 4">
                    <p>
                        <span class="item_subtitle">审核部门：</span>
                        <!-- <span class="content">{{ data.tendererName | projectIsEmpty }}</span> -->
                        <span class="content">{{ data.approveDeptName | projectIsEmpty }}</span>
                    </p>
                    <p>
                        <span class="item_subtitle">招标单位：</span>
                        <!-- <span class="content">{{ data.winerName | projectIsEmpty }}</span> -->
                        <span class="content">{{ data.tendererName | projectIsEmpty }}</span>
                    </p>
                </div>
                <div v-if="type == 4">
                    <p>
                        <span class="item_subtitle">监督部门：</span>
                        <span class="content">{{ data.superviseDeptName | projectIsEmpty }}</span>
                    </p>
                    <p>
                        <span class="item_subtitle">招标代理：</span>
                        <!-- <span class="content">{{ data.tenderMode | projectIsEmpty }}</span> -->
                        <span class="content">{{ data.tenderAgencyName | projectIsEmpty }}</span>
                    </p>
                </div>
                <div v-if="type == 4">
                    <p>
                        <span class="item_subtitle">开标时间：</span>
                        <span class="content">
                            {{ data.openTime | projectIsEmpty }}
                            <div v-if="data.passOpenDate&&data.passOpenDate>=0"></div>
                            <i
                                v-if="data.passOpenDate&&data.passOpenDate>=0"
                            >{{ data.passOpenDate == 0 ? '今日开标' : data.passOpenDate + '天后' }}</i>
                        </span>
                    </p>
                    <p></p>
                </div>
                <div>
                    <span class="lishi" style="color: #1890ff;">
                        历时
                        <br />
                        <span class="lishiText">{{ data.passDate }}</span>
                        <span
                            style="display:inline-block;transform:scale(0.7,0.7);color: #1890ff;"
                        >天</span>
                    </span>
                    <!-- <span style="color:#1890ff;right:0;cursor: pointer;margin-left:10px"
                    @click="handleCommand(data)">更多</span>-->
                    <!-- <el-dropdown style="float: right;right: -16px;top: -22px;" v-if="hasBtnPermission('btn_jz_witnessHis_'+businessType+'_show')"  @command="handleCommand">
							<span class="el-dropdown-link" style="cursor: pointer">
								更多<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="composeValue(0,data)">{{businessType|typeMapperProjectAngle}}</el-dropdown-item>
							<el-dropdown-item :command="composeValue(1,data)">{{businessType|typeMapperBidAngle}}</el-dropdown-item>
							<el-dropdown-item :command="composeValue(2,data)">招标代理视角</el-dropdown-item>
							<el-dropdown-item :command="composeValue(3,data)">投标人视角</el-dropdown-item>
							<el-dropdown-item :command="composeValue(4,data)">评委视角</el-dropdown-item>
							</el-dropdown-menu>
                    </el-dropdown>-->
                </div>
            </div>
            <div class="item_bottom">
                <div
                    class="step_item"
                    :style="{ width: (100 / data.flownodeList.length) + '%' }"
                    :class="classFn(item, i, data.flownodeList[data.flownodeList.length - 1])"
                    v-for="(item, i) in data.flownodeList"
                    :key="i"
                >
                    <template>
                        <template v-if="item.nodeName.indexOf('异常') >= 0">
                            <div
                                class="line left_line"
                                style="border-bottom-style:dashed"
                                :style="{ top: type == 4 ? '8px' : '' }"
                            ></div>
                        </template>
                        <template v-else>
                            <div class="line left_line" :style="{ top: type == 4 ? '8px' : '' }"></div>
                        </template>
                        <el-popover
                            placement="bottom"
                            width="428"
                            :open-delay="200"
                            :ref="'popover' + i"
                            :popper-class="`popover${i} myProjectPopover`"
                            :disabled="!item.flowId"
                            trigger="hover"
                            @show="getStepData($event, item.flowId, item.nodeProgressType, item, 'popover' + i)"
                        >
                            <div class="hover_div">
                                <div class="hover_bg" v-loading="loading">
                                    <div class="hover_con">
                                        <h3>{{ detailNodeName.nodeName }}审批流程</h3>
                                        <div
                                            class="hover_item"
                                            v-for="(item, i) in approvealData"
                                            :key="i"
                                        >
                                            <div class="hover_left">
                                                <span></span>
                                            </div>
                                            <div class="hover_right">
                                                <p class="title">{{ item.taskName }}</p>
                                                <p>提交人：{{ item.auditorName | projectIsEmpty }}</p>
                                                <p>
                                                    办理状态：
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        popper-class="tooltipBox"
                                                        :content="item.auditMsg"
                                                        placement="right"
                                                    >
                                                        <div
                                                            class="tooltipWidth"
                                                        >{{ item.auditMsg | projectIsEmpty }}</div>
                                                    </el-tooltip>
                                                </p>
                                                <p>任务创建时间：{{ item.startTime | projectIsEmpty }}</p>
                                                <p>任务提交时间：{{ item.endTime | projectIsEmpty }}</p>
                                                <p>提交用时：{{ item.costTimes | formatDuring }}</p>
                                            </div>
                                        </div>
                                        <div class="hover_item hover_item_end">
                                            <div class="hover_left">
                                                <span></span>
                                            </div>
                                            <div class="hover_right">
                                                <p class="title">结束</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="reference" class="item_temp">
                                <span
                                    v-if="processHandle(item, data.flownodeList[data.flownodeList.length - 1]) == 'pass'"
                                >
                                    <img src="@/assets/images/home/progress_blue.png" />
                                </span>
                                <span
                                    class="my_icon"
                                    v-else-if="processHandle(item, data.flownodeList[data.flownodeList.length - 1]) == 'ing'"
                                ></span>
                                <template v-else>
                                    <span
                                        class="my_icon my_icon1"
                                        style="width:16px;height:16px;border:1px solid #ccc;"
                                        v-if="type == 4"
                                    ></span>
                                    <span v-else class="my_icon">
                                        <img src="@/assets/images/home/progress_gray.png" />
                                    </span>
                                </template>
                                <em>
                                    <span>{{ item.nodeName }}</span>
                                </em>
                                <template
                                    v-if="data.flownodeList[i + 1] && data.flownodeList[i + 1].nodeName.indexOf('异常') >= 0"
                                >
                                    <div
                                        :class="rightLineClassFn1(item, i)"
                                        style="border-bottom-style:dashed"
                                        :style="{ top: type == 4 ? '8px' : '' }"
                                    ></div>
                                </template>
                                <template v-else>
                                    <div
                                        :class="rightLineClassFn2(item, i)"
                                        :style="{ top: type == 4 ? '8px' : '' }"
                                    ></div>
                                </template>
                            </div>
                        </el-popover>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { getNewTime, IsIE } from "@/utils/index";
import second from 'dayjs'
// import { listFlow } from '@/server/busWitnessList'

export default {
    props: {
        // 类型
        type: {
            type: Number,
            default: 1
        },
        data: {
            type: Object,
            default: function() {
                return {};
            }
        },
        hasViewBtnPer: {
            type: Boolean,
            default: true
        },
        systemType: {
            type: String,
            default: "GC"
        },
        keyCopy: {
            type: Number | String,
            default: 1
        },
        isShowTag: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            approvealData: [],
            composeValue(type, row) {
                return {
                    angleType: type,
                    item: row
                };
            },
            businessType: "",
            detailNodeName: {},
            isShow: true,
            keyflag: 1
        };
    },
    activated() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessHisBusinessType");
    },
    mounted() {
        this.businessType =
            this.busWitnessTableType ||
            window.sessionStorage.getItem("witnessHisBusinessType");
        if ($(".step_unusual")) {
            $(".step_unusual")
                .prev()
                .find(".right_line")
                .hide();
        } else {
            return;
        }
        this.keyflag = this.keyCopy;
        this.setClassName();
    },

    methods: {
        setClassName() {
            let color = ["#3FBF00", "#40A9FF", "#FFB92F"];
            let colorIndex = this.keyflag % 3;
            let c = "";
            switch (colorIndex) {
                case 0:
                    c = "TagGreen";
                    break;
                case 1:
                    c = "TagBlue";
                    break;
                case 2:
                    c = "TagYellow";
                    break;
                default:
                    c = "TagBlue";
                    break;
            }
            return c;
        },
        hideStep() {
            // this.isShow=false;
        },
        // 招标项目审批流程
        async getStepData(e, flowId, nodeProgressType, item, ref) {
            if (!flowId) {
                return;
            }
            // this.isShow=false
            if (nodeProgressType == 1 || nodeProgressType == 2) {
                this.detailNodeName.nodeName = item.nodeName;
                this.loading = true;
                this.$http
                    .get("/bidSection/listFlow?flowId=" + flowId)
                    .then(res => {
                        this.loading = false;
                        const { data } = res;
                        if (data.code == "1") {
                            this.approvealData = data.data;
                            this.$nextTick(() => {
                                this.$refs[ref][0].updatePopper();
                            });
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
            }
        },
        classFn(item, i, lastItem) {
            if (this.type == 4) {
                // type == 4   //  0未开始 1已完成 2 进行中
                if (item.nodeProgressType == 0) {
                    return "step_white";
                }
                if (item.nodeProgressType == 1 || item.nodeProgressType == 2) {
                    if (item.warningLevel == 0) {
                        return "step_blue";
                    }
                    if (item.warningLevel == 1) {
                        return "step_yellow";
                    }
                    if (item.warningLevel == 2) {
                        return "step_orange";
                    }
                    if (item.warningLevel == 3) {
                        return "step_red";
                    }
                }
            }

            if (item.nodeProgressType) {
                if (item.nodeProgressType == 2) {
                    return "step_ing";
                }
                return "step_pass";
            }
        },
        rightLineClassFn1(item, i) {
            //异常节点前节点的颜色
            if (item.nodeProgressType == 0) {
                return "line right_line gray";
            } else {
                if (
                    this.data.flownodeList[i + 1] &&
                    this.data.flownodeList[i + 1].nodeProgressType == 0
                ) {
                    return "line right_line gray";
                } else {
                    return "line right_line";
                }
            }
        },
        rightLineClassFn2(item, i) {
            //异常节点前节点的颜色
            if (
                item.nodeProgressType == 2 &&
                this.data.flownodeList[i + 1] &&
                this.data.flownodeList[i + 1].nodeProgressType == 0
            ) {
                return "line right_line gray";
            } else {
                return "line right_line";
            }
        },
        handleCommand(command) {
            if (this.type == 4) {
            	removeTabHandle("flow-efficiency-detail")
            	this.$router.push({
            		name: "flow-efficiency-detail",
            		query: {
            			businessId: command.businessId || '',
            		}
            	});
            	return;
            }
            let paramMap = {
            	tenderProjectCode: command.tenderProjectCode || '',
            	bidSectionCode: command.bidSectionCode || '',
            	bidSectionId: command.bidSectionId || '',
            	tradePlatfBidSectionId: command.tradePlatfBidSectionId || '',
            	projectCode: command.projectCode || '',
            	bidSectionName: command.bidSectionName || '',
            	applyCode: "",
            	idcard: "",
            }
            window.sessionStorage.setItem("witnessHisDetailParamMap", JSON.stringify(paramMap))
            // removeTabHandle('businessWitnessHis_detail')
            this.$router.push({
            	name: "businessWitnessHis_detail",
            	params: { paramMap: paramMap },
            	query: {
            		businessType: this.systemType,
            		angleType: command.angleType,
            		purchaserMode: command.purchaserMode || '',

            	},
            });

        },
        processHandle(item, lastItem) {
            if (this.type == 4) {
                return "blue";
            }
            if (item.nodeProgressType) {
                if (item.nodeProgressType == 2) {
                    return "ing";
                }
                return "pass";
            }
        },
        // 获取completeState为ture的projectState最大值
        getMax() {
            // console.log(this.data.buyprojectState)
            let max = this.data.flownodeList[0].projectState;
            // let max = this.data.buyprojectState;
            for (let i = 0; i < this.data.flownodeList.length - 1; i++) {
                if (this.data.flownodeList[i + 1].completeState) {
                    max =
                        Number(max) <
                        Number(this.data.flownodeList[i + 1].projectState)
                            ? Number(this.data.flownodeList[i + 1].projectState)
                            : Number(max);
                }
            }
            return max;
        },
        // 更多请求地址
        apijwtToJsgcProgress(temp) {
            apijwtToJsgcProgress(temp).then(res => {
                const { data } = res;
                if (data.code == "1") {
                    addPanel("跟踪详情", data.data);
                } else {
                    this.$alert(data.msg);
                }
            });
        },
        jumps(code) {
            removeTabHandle("early_warning_list");
            this.$router.push({
                name: "early_warning_list",
                query: {
                    itemName: code
                }
            });
        }
    },
    computed: {
        timeLater() {
            let timestamp = Date.parse(new Date(getNewTime()));
            let openTime = this.data.bidOpenTime;
            if (openTime) {
                // let openTimeStamp=1629497000000;
                let openTimeStamp = "";
                if (IsIE()) {
                    openTimeStamp = Date.parse(openTime.replace("-", "/"));
                } else {
                    openTimeStamp = Date.parse(openTime);
                }
                let temp = openTimeStamp - timestamp;
                if (temp == 0) {
                    return "今日开标";
                } else if (temp > 0) {
                    return Math.floor(temp / 1000 / 60 / 60 / 24);
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        // 计算历时时间
        durationTime() {
            let timestamp = Date.parse(new Date(getNewTime()));
            let createDataTamp = "";
            if (IsIE()) {
                createDataTamp = Date.parse(
                    this.data.createDate.replace("-", "/")
                );
            } else {
                createDataTamp = Date.parse(this.data.createDate);
            }
            if (this.data.projectEndTime) {
                let projectEndTamp = "";
                if (IsIE()) {
                    projectEndTamp = Date.parse(
                        this.data.projectEndTime.replace("-", "/")
                    );
                } else {
                    projectEndTamp = Date.parse(this.data.projectEndTime);
                }
                return Math.ceil(
                    (projectEndTamp - createDataTamp) / 1000 / 60 / 60 / 24
                );
            } else {
                return Math.ceil(
                    (timestamp - createDataTamp) / 1000 / 60 / 60 / 24
                );
            }
        }
    },
    filters: {
        typeMapperProjectAngle: function(type) {
            switch (type) {
                case "GC":
                    return "项目（标段）视角";
                    break;
                case "CG":
                    return "项目（包件）视角";
                    break;
                case "CQ":
                    return "项目（标段）视角";
                    break;
                case "GT":
                    return "项目（标段）视角";
                    break;
                case "QT":
                    return "项目（标段）视角";
                    break;
                default:
                    return "项目（标段）视角";
                    break;
            }
        },
        typeMapperBidAngle: function(type) {
            switch (type) {
                case "GC":
                    return "招标人";
                    break;
                case "CG":
                    return "采购人";
                    break;
                case "CQ":
                    return "招标人";
                    break;
                case "GT":
                    return "招标人";
                    break;
                case "QT":
                    return "招标人";
                    break;
                default:
                    return "招标人";
                    break;
            }
        },
        formatDuring(num1) {
            var num = parseInt(num1 / 1000);
            var s = num % 60;
            num = parseInt(num / 60);
            var m = num % 60;
            num = parseInt(num / 60);
            var h = num % 24;
            num = parseInt(num / 24);
            var d = num;
            return d + "天" + h + "小时" + m + "分钟" + s + "秒";
        },
        projectIsEmpty(value) {
            if (!value) {
                return "/";
            } else {
                return value;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-tooltip {
    display: inline-block;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}

.project_com_item {
    position: relative;
    background: rgba(239, 243, 246, 0.26);
    border-radius: 3px;
    border: 1px solid rgba(204, 204, 204, 0.28);
    border-bottom: 1px solid rgba(204, 204, 204, 0.28);
    cursor: pointer;
    margin-top: 16px;
    em {
        color: #000000;
    }

    .item_top {
        padding: 0 15px;
        height: 56px;
        background: #e7f3ff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // #3FBF00=漯河市；#40A9FF=舞阳县；#FFB92F=临颍县
        .TagGreen {
            background-color: #3fbf00;
        }
        .flagTag.TagGreen::before {
            content: "";
            width: 0;
            height: 0;
            border-right: 3px solid #3fbf00;
            border-bottom: 3px solid transparent;
            position: absolute;
            left: 0px;
            top: 32px;
        }
        .flagTag.TagGreen::after {
            content: "";
            width: 0;
            height: 0;
            border-left: 16px solid #3fbf00;
            border-top: 16px solid transparent;
            border-bottom: 16px solid transparent;
            position: absolute;
            right: -16px;
            top: 0;
        }
        .TagBlue {
            background-color: #40a9ff;
        }
        .flagTag.TagBlue::before {
            content: "";
            width: 0;
            height: 0;
            border-right: 3px solid #40a9ff;
            border-bottom: 3px solid transparent;
            position: absolute;
            left: 0px;
            top: 32px;
        }
        .flagTag.TagBlue::after {
            content: "";
            width: 0;
            height: 0;
            border-left: 16px solid #40a9ff;
            border-top: 16px solid transparent;
            border-bottom: 16px solid transparent;
            position: absolute;
            right: -16px;
            top: 0;
        }
        .TagYellow {
            background-color: #ffb92f;
        }
        .flagTag.TagYellow::before {
            content: "";
            width: 0;
            height: 0;
            border-right: 3px solid #ffb92f;
            border-bottom: 3px solid transparent;
            position: absolute;
            left: 0px;
            top: 32px;
        }
        .flagTag.TagYellow::after {
            content: "";
            width: 0;
            height: 0;
            border-left: 16px solid #ffb92f;
            border-top: 16px solid transparent;
            border-bottom: 16px solid transparent;
            position: absolute;
            right: -16px;
            top: 0;
        }
        .flagTag {
            display: inline-block;
            vertical-align: middle;
            width: 72px;
            height: 32px;
            color: #ffffff;
            line-height: 32px;
            text-align: center;
            position: relative;
            left: -18px;
        }

        .title {
            color: #000000;
            font-size: 16px;
            font-weight: bold;
            vertical-align: middle;
        }

        .tag {
            color: #1890ff;
            font-size: 12px;
            background: #e7f3ff;
            border-radius: 3px;
            border: 1px solid #1890ff;
            margin-left: 8px;
            padding: 5px 8px;
            position: relative;
            // &:after{
            // 	content: '';
            // 	width: 8px;
            // 	height: 8px;
            // 	position: absolute;
            // 	border: 1px solid #1890FF;
            // 	border-radius: 50%;
            // 	left: 8px;
            // 	top: 50%;
            // 	transform: translate(0,-50%);
            // }
        }

        .item_top_time {
            cursor: pointer;

            span {
                color: #000000;
                font-size: 14px;
                // font-weight: bold;
                margin-right: 10px;
            }

            img {
                width: 16px;
                margin-top: -5px;
            }
        }

        .zero {
            color: #333333 !important;
        }

        .one {
            color: #ff9933 !important;
        }

        .two {
            color: #ff0052 !important;
        }
    }

    .my_padding {
        padding: 0 20px;
        .lishi {
            width: 50px;
            height: 50px;
            background-color: #e7f5ff;
            text-align: center;
            line-height: 25px;
            .lishiText {
                font-weight: bold;
                font-size: 18px;
                color: #1890ff;
            }
        }
    }

    .item_middle {
        padding: 12px 8px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > div {
            flex: 3;

            p {
                // height: 48px;
                height: 17px;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                span {
                    font-size: 14px;
                    color: #000000;
                }

                .item_subtitle {
                    display: inline-block;
                    width: 100px;
                    text-align: right;
                    // color: rgba($color: #000000, $alpha: 0.85);
                    color: #000000;
                }

                .content {
                    color: rgba(0, 0, 0, 0.85);
                    display: inline-block;
                    width: calc(100% - 100px);
                    display: flex;
                    align-items: center;

                    div {
                        border-style: solid;
                        border-width: 13px 12px 13px 0;
                        border-color: transparent rgba(245, 107, 108, 0.1)
                            transparent transparent;
                        width: 0px;
                        height: 0px;
                        margin-left: 10px;
                    }

                    i {
                        font-style: normal;
                        font-size: 14px;
                        color: #f56b6c;
                        background: rgba(245, 107, 108, 0.1);
                        padding: 5px 15px 5px 8px;
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                    }
                }
            }
        }

        & > div:last-child {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-left: auto;

            & > span {
                &:first-child {
                    color: #8d8d8d;
                }
            }

            /deep/ .el-dropdown {
                top: 0 !important;
                color: #1890ff;
            }
        }

        .content {
            box-shadow: none;
            background: none;
        }
    }
}
.project_com_item:hover {
    background-color: #eff3f6;
    border: 1px solid #1890ff;
}
// .item_bottom .step_item .my_icon{
// 	width: 16px;
// 	height: 16px;
// }
// .item_bottom .step_item .line{
// 	top: 8px;
// }
.item_bottom .step_blue .line,
.item_bottom .step_yellow .line,
.item_bottom .step_red .line {
    border-color: rgb(24, 144, 255);
}

.step_blue .my_icon {
    background: rgb(24, 144, 255);
    border-color: rgb(24, 144, 255);
}

.step_yellow .my_icon {
    background: #ffc500;
    border-color: #ffc500;
}

.step_orange .my_icon {
    background: #ff9900;
    border-color: #ff9900;
}

.step_red .my_icon {
    background: rgb(242, 48, 48);
    border-color: rgb(242, 48, 48);
}

.step_white .my_icon {
    background: #ffffff;
    border-color: #ffffff;
}
</style>
